import React from "react";
import "./CollectionBox.css";

import { Link } from "react-router-dom";

const CollectionBox = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="collection">
        <div className="collectionLeft">
          <p className="col-p">TOP LISTA</p>
          <h3 className="col-h3">
            <span>Ženska</span> Kolekcija
          </h3>
          <div className="col-link">
            <Link to="/shop?collection=women" onClick={scrollToTop}>
              <h5>Pogledaj odmah</h5>
            </Link>
          </div>
        </div>
        <div className="collectionRight">
          <div className="collectionTop">
            <p className="col-p">TOP LISTA</p>
            <h3 className="col-h3">
              <span>Muška</span> Kolekcija
            </h3>
            <div className="col-link">
              <Link to="/shop?collection=men" onClick={scrollToTop}>
                <h5>Pogledaj odmah</h5>
              </Link>
            </div>
          </div>
          <div className="collectionBottom">
            <div className="box1">
              <p className="col-p">TOP LISTA</p>
              <h3 className="col-h3">
                <span>Dječija</span> Kolekcija
              </h3>
              <div className="col-link">
                <Link to="/shop?collection=children" onClick={scrollToTop}>
                  <h5>Pogledaj odmah</h5>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CollectionBox;
